import { useContent } from '../../../hooks/use-server-content';

export interface DyfFdsButtonProps {
    buttonType: string;
    buttonLabel: string;
    buttonOutlined?: boolean;
    buttonChevron?: string;
    buttonHref?: string;
    buttonDisabled?: boolean;
    buttonTheme?: string;
    buttonPreventDefault?: boolean;
    buttonNoShadow?: boolean;
}
export const useDyfFdsButtonContent = (name: string): DyfFdsButtonProps => {
    const [content, getValueByName] = useContent(
        'dyf/feature-guide',
        `dyf-landing-${name}-card-button`
    );
    const contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    return contentFragment as DyfFdsButtonProps;
};
